import { LftSkeleton } from '@lift/design-system-react-web/dist/components';
import { Curso } from '../../../../../models/usuario.model';
import { InputSearch } from '../../../../input-search/input-search.component';
import S from '../../../app-container.styles';
import { LeadContentProps } from '../../../app-container.types';

export const LeadContent: React.FC<LeadContentProps> = ({
  listaCurso,
  tagPropsMapeadas,
  tagSelecionada,
  setTagSelecionada,
  listaCursoFiltrada,
  selecionarCurso,
}) =>
  listaCurso?.length ? (
    <InputSearch<Curso>
      tag={{
        tagPropsMapeadas,
        tagSelecionada,
        setTagSelecionada,
      }}
      inputSearch={{
        placeholder: 'Buscar curso',
        className: 'listaCursos',
        dataElement: 'selecionar-curso',
        dataSection: 'section_busca-cursos',
      }}
      listaMenu={{
        itensFiltrados: listaCursoFiltrada(),
        atualizaItem: selecionarCurso,
      }}
    />
  ) : (
    <S.SkeletonContainer className="skeleton-container">
      <LftSkeleton shape="square" id="skeleton-lista-curso" height="3.5rem" />
    </S.SkeletonContainer>
  );
